import React from 'react';
import UnifiedAuthCard from '../components/UnifiedAuthCard';

const LoginPage = () => {
    return <UnifiedAuthCard defaultMode="login" />;
};

export default LoginPage;
